import controller from './thing-picture.controller';

const template = require('./thing-picture.html');

export default {
    bindings: {
        reset: '<',
        pushUpdate: '&',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-picture/thing-picture.component.js